import type { HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ColumnsProps } from './types.js';

/** Columns component. */
export const Columns = ({ children, className, ...props }: ColumnsProps): ReactElement => (
  <div className={twMerge('grid grid-cols-2 gap-24', className)} {...props}>
    {children}
  </div>
);

const Column = ({ children, className, ...props }: HtmlAttributesWithChildren): ReactElement => (
  <div className={twMerge('flex flex-col gap-24 [&>h3]:mb-0', className)} {...props}>
    {children}
  </div>
);

Columns.Column = Column;
